import Swiper, { Navigation, Pagination } from 'swiper';
import GLightbox from 'glightbox';
import {Tab} from 'bootstrap'
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'glightbox/dist/css/glightbox.css'
// init Swiper:
// const swiper = new Swiper('.swiper', {
//   // configure Swiper to use modules
//   modules: [Navigation, Pagination],
  
// });

const lightbox = GLightbox({
    selector:".button",
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});
const lightbox2 = GLightbox({
    selector:"._incatrail",
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});
const gallery = GLightbox({
    selector:".gallery a",
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});
const popup = GLightbox({
    selector:".popup",
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});
const popup1 = GLightbox({
    selector:".popup1",
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});
const popup2 = GLightbox({
    selector:".popup2",
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});
const popup3 = GLightbox({
    selector:".popup3",
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});
var swipersss = new Swiper(".mySwiper", {
    modules: [Navigation, Pagination],
    slidesPerView: 3,
    spaceBetween: 30,
            breakpoints: {
            '1000': {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            '800': {
                slidesPerView: 3,
                spaceBetween: 5,
            },
            '700': {
                slidesPerView: 2,
                spaceBetween: 5,
            },
            '600': {
                slidesPerView: 1,
                spaceBetween: 5,
            },
            '500': {
                slidesPerView: 1,
                spaceBetween: 5,
            },
            '400': {
                slidesPerView: 1,
                spaceBetween: 5,
            },
            '300': {
                slidesPerView: 1,
                spaceBetween: 5,
            },
        },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

var swiperss = new Swiper(".homeSlider", {
    modules: [Navigation, Pagination],
    pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
});

var swipersss = new Swiper(".slider1", {
    modules: [Navigation, Pagination],
    slidesPerView: 3,
    spaceBetween: 10,
    breakpoints: {
        '1000': {
            slidesPerView: 3,
            spaceBetween: 10,
        },
        '800': {
            slidesPerView: 3,
            spaceBetween: 5,
        },
        '700': {
            slidesPerView: 2,
            spaceBetween: 5,
        },
        '600': {
            slidesPerView: 1,
            spaceBetween: 5,
        },
        '500': {
            slidesPerView: 1,
            spaceBetween: 5,
        },
        '400': {
            slidesPerView: 1,
            spaceBetween: 5,
        },
        '300': {
            slidesPerView: 1,
            spaceBetween: 5,
        },
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  });
// */
  var adwords = new Swiper(".wfooter", {

    slidesPerView: 3,
    spaceBetween: 10,
    breakpoints: {
        '1000': {
            slidesPerView: 5,
            spaceBetween: 10,
        },
        '800': {
            slidesPerView: 4,
            spaceBetween: 5,
        },
        '700': {
            slidesPerView: 4,
            spaceBetween: 5,
        },
        '600': {
            slidesPerView: 4,
            spaceBetween: 5,
        },
        '500': {
            slidesPerView: 3,
            spaceBetween: 5,
        },
        '320': {
            slidesPerView: 2,
            spaceBetween: 5,
        },
    },
  });
// */*********************** */
import JustGage from 'justgage'
var g1 = new JustGage({
    id: 'g1',
    value: 1,
    min: 0,
    max: 5,
    title: "EASY",
    symbol: '',
    pointer: true,
    pointerOptions: {
        toplength: -15,
        bottomlength: 10,
        bottomwidth: 12,
        color: '#8e8e93',
        stroke: '#ffffff',
        stroke_width: 3,
        stroke_linecap: 'round'
    },
    gaugeWidthScale: 0.6,
    counter: true
});

var g2 = new JustGage({
    id: 'g2',
    value: 2,
    min: 0,
    max: 5,
    title: "MILD",
    symbol: '',
    pointer: true,
    pointerOptions: {
        toplength: -15,
        bottomlength: 10,
        bottomwidth: 12,
        color: '#8e8e93',
        stroke: '#ffffff',
        stroke_width: 3,
        stroke_linecap: 'round'
    },
    gaugeWidthScale: 0.6,
    counter: true
});

var g3 = new JustGage({
    id: 'g3',
    value: 3,
    min: 0,
    max: 5,
    title: "MODERATE",
    symbol: '',
    pointer: true,
    pointerOptions: {
        toplength: -15,
        bottomlength: 10,
        bottomwidth: 12,
        color: '#8e8e93',
        stroke: '#ffffff',
        stroke_width: 3,
        stroke_linecap: 'round'
    },
    gaugeWidthScale: 0.6,
    counter: true
});

var g4 = new JustGage({
    id: 'g4',
    value: 4,
    min: 0,
    max: 5,
    title: "CHALLENGING",

    symbol: '',
    pointer: true,
    pointerOptions: {

        color: '#8e8e93',
        stroke: '#ffffff',
        stroke_width: 3,
        stroke_linecap: 'round'
    },
    counter: true
});
// var g4 = new JustGage({
//     id: "g4",
//     value: 4,
//     min: 0,
//     max: 100,
//     title: "CHALLENGING",
//     label: "",
//     levelColorsGradient: false
//   });

var g5 = new JustGage({
    id: 'g5',
    value: 5,
    min: 0,
    max: 5,
    title: "FORMIDABLE",
    symbol: '',
    pointer: true,
    pointerOptions: {
        toplength: -15,
        bottomlength: 10,
        bottomwidth: 12,
        color: '#8e8e93',
        stroke: '#ffffff',
        stroke_width: 3,
        stroke_linecap: 'round'
    },
    gaugeWidthScale: 0.6,
    counter: true
});
